import { Link } from "react-router-dom";
import { focusRing } from "../ui/focusRing";

interface SiteFooterProps {
  variant: "home" | "docs" | "legal";
}

function SiteFooter({ variant }: SiteFooterProps) {
  const copyrightText =
    variant === "home"
      ? "© 2026–present Ninefold • Made with ❤️ for happy teams"
      : "© 2026 Ninefold • Made with ❤️ for happy teams";

  const showDocsLink = variant === "home" || variant === "docs";
  const copyrightClass = variant === "home" ? "text-sm text-stone-600" : "text-sm text-stone-500";

  return (
    <footer className="py-12 px-6 bg-white border-t border-orange-200">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6">
        <div className="flex items-center gap-2">
          <img src="/logo.webp" alt="Kyubot" className="w-6 h-6" />
          <span className="font-bold text-stone-800">Kyubot</span>
        </div>
        <div className="flex gap-6 text-sm text-stone-600">
          {showDocsLink && (
            <Link to="/docs" className={`hover:text-brand-orange transition-colors ${focusRing}`}>
              Docs
            </Link>
          )}
          <Link to="/privacy" className={`hover:text-brand-orange transition-colors ${focusRing}`}>
            Privacy
          </Link>
          <Link to="/terms" className={`hover:text-brand-orange transition-colors ${focusRing}`}>
            Terms
          </Link>
          <a
            href="mailto:support@kyubot.com"
            className={`hover:text-brand-orange transition-colors ${focusRing}`}
          >
            Support
          </a>
        </div>
        <p className={copyrightClass}>{copyrightText}</p>
      </div>
    </footer>
  );
}

export default SiteFooter;
